module.exports = __webpack_public_path__ + "static/media/SWSCRC6-48.15afdc57.mp3";